import type { NavItem, Office } from '@/types'

/**
 * The full index, numbered 00 to 10. The menu and the footer both read it; Contact stays a separate
 * button in the header and the last item of the footer index.
 */
export const MENU_ITEMS: Array<NavItem> = [
    { href: '/', label: 'Home', index: '00' },
    { href: '/practice', label: 'Practice', index: '01' },
    { href: '/platform', label: 'Platform', index: '02' },
    { href: '/projects', label: 'Projects', index: '03' },
    { href: '/live-model', label: 'Live Model', index: '04' },
    { href: '/atlas', label: 'Atlas', index: '05' },
    { href: '/process', label: 'Process', index: '06' },
    { href: '/materials', label: 'Materials', index: '07' },
    { href: '/field-reports', label: 'Field Reports', index: '08' },
    { href: '/studio', label: 'Studio', index: '09' },
    { href: '/recognition', label: 'Recognition', index: '10' }
]

/**
 * The short list shown inline in the desktop header, keeping the index numbers of the full menu.
 */
export const NAV_ITEMS: Array<NavItem> = MENU_ITEMS.filter(item => ['/platform', '/projects', '/live-model', '/field-reports'].includes(item.href))

export const CONTACT_ITEM: NavItem = { href: '/contact', label: 'Contact', index: '11' }

export const OFFICES: Array<Office> = [
    {
        city: 'Stockholm',
        code: 'STO',
        timeZone: 'Europe/Stockholm',
        lat: 59.3293,
        lon: 18.0686,
        coords: '59.3293° N / 18.0686° E',
        address: ['Hornsgatan 64', '118 21 Stockholm', 'Sweden'],
        phone: '+46 8 410 237 00',
        phoneHref: 'tel:+46841023700'
    },
    {
        city: 'Lisbon',
        code: 'LIS',
        timeZone: 'Europe/Lisbon',
        lat: 38.7223,
        lon: -9.1393,
        coords: '38.7223° N / 9.1393° W',
        address: ['Rua da Junqueira 112', '1300-344 Lisboa', 'Portugal'],
        phone: '+351 213 640 180',
        phoneHref: 'tel:+351213640180'
    },
    {
        city: 'New York',
        code: 'NYC',
        timeZone: 'America/New_York',
        lat: 40.7222,
        lon: -73.9967,
        coords: '40.7222° N / 73.9967° W',
        address: ['210 Lafayette Street', 'New York, NY 10012', 'United States'],
        phone: '+1 212 555 0148',
        phoneHref: 'tel:+12125550148'
    }
]
